// Stub for backend-only modules to prevent Node.js dependencies from being bundled in browser
// This file is used by Vite to replace backend imports that should not run in the browser

import { z } from 'zod'

// Minimal Big.js stub for browser
class BigStub {
  constructor(value) {
    this.value = typeof value === 'string' ? parseFloat(value) : value
  }

  static strict = true
  static DP = 2
  static RM = 1

  toString() {
    return String(this.value)
  }

  toFixed(dp) {
    return this.value.toFixed(dp)
  }

  valueOf() {
    return this.value
  }
}

// Export Big class
export const Big = BigStub

// Export numericSchema as z.instanceof(Big)
export const numericSchema = z.instanceof(BigStub)

// Stub other exports that might be imported
export const normalizeRowColumn = (val) => val
export const denormalizeRowColumn = (val) => val

export default {
  Big,
  numericSchema,
  normalizeRowColumn,
  denormalizeRowColumn,
}
